import api from "./client";

export default {
    getData(userID, data={}) {
        return api.post('/app/getData/' + userID, data);
    },
    getLanguage(lang) {
        return api.get('/getLanguage/' + lang);
    },
    getDirectoryNavigation(data) {
        return api.post('/directory/getNavigation', data);
    },
    getDirectory(data) {
        if (data.page != undefined) {
            return api.post('/directory/getDirectory?page=' + data.page, data);
        }
        return api.post('/directory/getDirectory', data);
    },
    setFeedback(data) {
        return api.post('/directory/setFeedback', {data:data});
    },
    getProfile(user_id) {
        return api.get('/getProfile/' + user_id + '?render=1');
    },
    search(q, page) {
        return api.post('/directory/search?page=' + page, {q: q});
    },
}

